import Translations from '@helpers/translations'
import { FormContentProps } from './types'

export function getBulletLabels(id: string) {
  switch (id) {
    case 'how_likely_are_you_to_recommend':
      return {
        leftLabel: Translations.localise('pages.feedback.answers.least-likely'),
        rightLabel: Translations.localise('pages.feedback.answers.most-likely')
      }
    case 'price_to_value':
      return {
        leftLabel: Translations.localise('pages.feedback.answers.poor-value'),
        rightLabel: Translations.localise(
          'pages.feedback.answers.excellent-value'
        )
      }
    case 'site_navigation':
      return {
        leftLabel: Translations.localise(
          'pages.feedback.answers.very-difficult'
        ),
        rightLabel: Translations.localise('pages.feedback.answers.very-easy')
      }
    default:
      return {
        leftLabel: Translations.localise('pages.feedback.answers.very-poor'),
        rightLabel: Translations.localise('pages.feedback.answers.excellent')
      }
  }
}

export function toggleQuestionsVisibility(
  values: Record<string, string>,
  questions: FormContentProps['data'][]
): FormContentProps['data'][] {
  const dynamicQuestionIds = [
    'new_products',
    'how_can_we_improve_fit',
    'find_the_product_you_wanted'
  ]

  const rawFit = values['rate_fit']
  const rawSiteNavigation = values['site_navigation']

  const fitRating =
    rawFit !== undefined && rawFit !== '' ? Number(rawFit) : null
  const siteNavigation =
    rawSiteNavigation !== undefined && rawSiteNavigation !== ''
      ? Number(rawSiteNavigation)
      : null

  const visibleDynamicQuestionIds: string[] = []

  if (fitRating !== null) {
    if (fitRating < 8) visibleDynamicQuestionIds.push('how_can_we_improve_fit')
    else visibleDynamicQuestionIds.push('new_products')
  }

  if (siteNavigation !== null && siteNavigation <= 4) {
    visibleDynamicQuestionIds.push('find_the_product_you_wanted')
  }

  return questions.map(question => {
    if (!dynamicQuestionIds.includes(question.id)) return question

    const shouldBeVisible = visibleDynamicQuestionIds.includes(question.id)
    return { ...question, hidden: !shouldBeVisible }
  })
}
